import * as yup from 'yup';
import { StringSchema } from 'yup';

export const getConfirmPasswordSchema = (passwordField: string, label: string): StringSchema =>
  yup
    .string()
    .oneOf([yup.ref(passwordField), null], `The ${label} must match the New Password entry`)
    .required()
    .label(label);
